export const stripHtml = (value = "") =>
  value
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, "")
    .trim();

export const requiredRichTextValidator = (args) => {
  const { value } = args;

  const clean = stripHtml(value || "");

  if (!clean) {
    return {
      succeeded: false,
      type: "required_rich_text",
      message: "This field is required",
    };
  }

  return {
    succeeded: true,
    type: "required_rich_text",
    message: "",
  };
};